import { render, staticRenderFns } from "./customers-new.vue?vue&type=template&id=3b34e97f"
import script from "./customers-new.vue?vue&type=script&lang=js"
export * from "./customers-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports